/** @format */
import QRCode from '../../Shared/Components/QRCode';
import _ from 'lodash';
import DefaultImg from '../../Assets/Images/default.png';

const PreviewLive = ({
	cardLoading,
	eventContext,
	removeField,
	removeQRCode,
	removeSignature,
}) => {
	return (
		<div className='row border rounded p-2 my-3'>
			<div className='col-12 d-flex flex-column justify-content-start mb-3 border-bottom py-2'>
				<h1 className='text-dark f-14 font-weight-bold'>نمایش زنده تغیرات</h1>
			</div>
			<div className='col-12 d-flex flex-row justify-content-center align-content-center'>
				{cardLoading ? (
					<div
						className='spinner-border spinner-border-sm text-white mb-1'
						role='status'></div>
				) : (
					<div
						className='border rounded border-dark position-relative'
						style={{
							width: `${eventContext.idCardFields.width}cm`,
							height: `${eventContext.idCardFields.height}cm`,
							backgroundImage: `url(${eventContext.idCardFields.background_image})`,
							backgroundSize: 'contain',
							backgroundRepeat: 'no-repeat',
						}}>
						{eventContext.idCardFields.fields?.map((item) => (
							<>
								{item.type == 'img' ? (
									<div
										style={{
											position: 'absolute',
											top: item[`top_${item.name}`] + 'px',
											right: item[`right_${item.name}`] + 'px',
											left: item[`left_${item.name}`] + 'px',
											bottom: item[`bottom_${item.name}`] + 'px',
											width: item[`width_${item.name}`] + 'px',
											height: item[`height_${item.name}`] + 'px',
										}}>
										<img
											className='font-weight-bold w-100 h-100 rounded'
											style={{
												backgroundSize: 'contain',
											}}
											src={DefaultImg}
											alt=''
										/>
									</div>
								) : (
									<span
										className='font-weight-bold'
										style={{
											position: 'absolute',
											top: item[`top_${item.name}`] + 'px',
											right: item[`right_${item.name}`] + 'px',
											left: item[`left_${item.name}`] + 'px',
											bottom: item[`bottom_${item.name}`] + 'px',
											color: '#000',
											fontSize: eventContext.idCardFields?.font_size + 'px',
										}}>
										
										<i
											onClick={() => removeField(item.name)}
											className='fad fa-minus-hexagon c-pointer f-15 text-danger position-absolute'
											style={{ top: 0, right: '-20px' }}></i>
										{item.value}
									</span>
								)}
							</>
						))}
						{!_.isEmpty(eventContext.idCardFields.signature) ? (
							<div className='d-flex flex-column'>
								<i
									onClick={() => removeSignature()}
									className='fad fa-minus-hexagon c-pointer f-15 text-danger'
									style={{
										position: 'absolute',
										top:
											eventContext.idCardFields.signature?.title_top -
											10 +
											'px',
										right:
											eventContext.idCardFields.signature?.title_right -
											10 +
											'px',
										left:
											eventContext.idCardFields.signature?.title_left -
											10 +
											'px',
										bottom:
											eventContext.idCardFields.signature?.title_bottom -
											10 +
											'px',
										zIndex: '999999999',
									}}></i>
								<span
									className='font-weight-bold'
									style={{
										position: 'absolute',
										top: eventContext.idCardFields.signature?.title_top + 'px',
										right:
											eventContext.idCardFields.signature?.title_right + 'px',
										left:
											eventContext.idCardFields.signature?.title_left + 'px',
										bottom:
											eventContext.idCardFields.signature?.title_bottom + 'px',
										color: '#000',
										fontSize: eventContext.idCardFields?.font_size + 'px',
									}}>
									{eventContext.idCardFields.signature?.title ?? ''}
								</span>
								<img
									src={eventContext.idCardFields.signature?.image ?? ''}
									style={{
										width: eventContext.idCardFields.signature?.width + 'px',
										height: eventContext.idCardFields.signature?.height + 'px',
										position: 'absolute',
										top: eventContext.idCardFields.signature?.image_top + 'px',
										right:
											eventContext.idCardFields.signature?.image_right + 'px',
										left:
											eventContext.idCardFields.signature?.image_left + 'px',
										bottom:
											eventContext.idCardFields.signature?.image_bottom + 'px',
									}}
									alt=''
								/>
							</div>
						) : null}

						{!_.isEmpty(eventContext.idCardFields.qrCode) ? (
							<div
								className='d-flex position-absolute'
								style={{
									top: `${eventContext.idCardFields.qrCode?.top}px`,
									right: `${eventContext.idCardFields.qrCode?.right}px`,
									left: `${eventContext.idCardFields.qrCode?.left}px`,
									bottom: `${eventContext.idCardFields.qrCode?.bottom}px`,
								}}>
								<i
									onClick={() => removeQRCode()}
									className='fad fa-minus-hexagon c-pointer f-15 text-danger'
									style={{
										position: 'absolute',
										top: '0',
										right: '-20px',
										left: '0',
										bottom: '0',
									}}></i>
								<QRCode
									width={
										eventContext.idCardFields.qrCode?.width != undefined
											? eventContext.idCardFields.qrCode?.width
											: 100
									}
									height={
										eventContext.idCardFields.qrCode?.height != undefined
											? eventContext.idCardFields.qrCode?.height
											: 100
									}
									value={eventContext.idCardFields.qrCode?.url}
								/>
							</div>
						) : null}
					</div>
				)}
			</div>
		</div>
	);
};

export default PreviewLive;
